// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { DoorStatus } from './door-status';


export class DoorStatusMessage implements flatbuffers.IUnpackableObject<DoorStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):DoorStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsDoorStatusMessage(bb:flatbuffers.ByteBuffer, obj?:DoorStatusMessage):DoorStatusMessage {
  return (obj || new DoorStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsDoorStatusMessage(bb:flatbuffers.ByteBuffer, obj?:DoorStatusMessage):DoorStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new DoorStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():DoorStatus {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : DoorStatus.RearDoorOpenSequence;
}

static startDoorStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:DoorStatus) {
  builder.addFieldInt16(0, message, DoorStatus.RearDoorOpenSequence);
}

static endDoorStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createDoorStatusMessage(builder:flatbuffers.Builder, message:DoorStatus):flatbuffers.Offset {
  DoorStatusMessage.startDoorStatusMessage(builder);
  DoorStatusMessage.addMessage(builder, message);
  return DoorStatusMessage.endDoorStatusMessage(builder);
}

unpack(): DoorStatusMessageT {
  return new DoorStatusMessageT(
    this.message()
  );
}


unpackTo(_o: DoorStatusMessageT): void {
  _o.message = this.message();
}
}

export class DoorStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: DoorStatus = DoorStatus.RearDoorOpenSequence
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return DoorStatusMessage.createDoorStatusMessage(builder,
    this.message
  );
}
}
